/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { MainPageTag } from './MainPageTag'
import { MainPageTagFromJSON, MainPageTagFromJSONTyped, MainPageTagToJSON } from './MainPageTag'

/**
 *
 * @export
 * @interface CategoryAdmin
 */
export interface CategoryAdmin {
  /**
   *
   * @type {number}
   * @memberof CategoryAdmin
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof CategoryAdmin
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof CategoryAdmin
   */
  iconImg?: string | null
  /**
   *
   * @type {number}
   * @memberof CategoryAdmin
   */
  readonly objectsAmount: number
  /**
   *
   * @type {number}
   * @memberof CategoryAdmin
   */
  readonly servicesAmount: number
  /**
   *
   * @type {string}
   * @memberof CategoryAdmin
   */
  backgroundImg?: string | null
  /**
   *
   * @type {boolean}
   * @memberof CategoryAdmin
   */
  isVisible?: boolean | null
  /**
   *
   * @type {boolean}
   * @memberof CategoryAdmin
   */
  readonly fromCrm: boolean
  /**
   *
   * @type {MainPageTag}
   * @memberof CategoryAdmin
   */
  readonly tag: MainPageTag | null
}

/**
 * Check if a given object implements the CategoryAdmin interface.
 */
export function instanceOfCategoryAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value
  isInstance = isInstance && 'objectsAmount' in value
  isInstance = isInstance && 'servicesAmount' in value
  isInstance = isInstance && 'fromCrm' in value
  isInstance = isInstance && 'tag' in value

  return isInstance
}

export function CategoryAdminFromJSON(json: any): CategoryAdmin {
  return CategoryAdminFromJSONTyped(json, false)
}

export function CategoryAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CategoryAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    name: !exists(json, 'name') ? undefined : json['name'],
    iconImg: !exists(json, 'iconImg') ? undefined : json['iconImg'],
    objectsAmount: json['objectsAmount'],
    servicesAmount: json['servicesAmount'],
    backgroundImg: !exists(json, 'backgroundImg') ? undefined : json['backgroundImg'],
    isVisible: !exists(json, 'isVisible') ? undefined : json['isVisible'],
    fromCrm: json['fromCrm'],
    tag: MainPageTagFromJSON(json['tag']),
  }
}

export function CategoryAdminToJSON(value?: CategoryAdmin | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    iconImg: value.iconImg,
    backgroundImg: value.backgroundImg,
    isVisible: value.isVisible,
  }
}
